import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=338e3ed7&scoped=true&"
import script from "./addOrEdit.vue?vue&type=script&lang=js&"
export * from "./addOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338e3ed7",
  null
  
)

export default component.exports